import Tooltip from '@mui/material/Tooltip'
import { ReactFragment, ReactNode } from 'react'
import { Box, Fade } from '@mui/material'

type TooltipTextProps = {
  height?: string
  text: string | ReactFragment
  children: ReactNode
}

export const TooltipText = ({ text, height, children }: TooltipTextProps) => {
  return (
    <Tooltip
      placement='top'
      TransitionComponent={Fade}
      arrow
      title={text}
      sx={{ height }}>
      <Box display='flex' alignItems='center'>
        {children}
      </Box>
    </Tooltip>
  )
}
